import { render } from "./ItemCard.vue?vue&type=template&id=6c2f81cc"
import script from "./ItemCard.vue?vue&type=script&lang=js"
export * from "./ItemCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__